import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../apiSetup/apiCall";

export const sessionRangeData = createAsyncThunk("session/fetchSessionRangeData", async ({ facilityId, startDate, endDate }) => {
    try {
      const response = await api.get(`prometheus/facility/${facilityId}/details/${startDate}/${endDate}/`);
      return response.data;
    } catch (error) {
      console.error("Error fetching session data:", error);
      throw error;
    }
});

const SessionRangeSlice = createSlice({
  name: "sessionRange",
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sessionRangeData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(sessionRangeData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(sessionRangeData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});
export default SessionRangeSlice.reducer;
